export const qualtricsTags = {
  FEEDBACK: () => {
    return {
      event: 'feedback',
    };
  },
  CLAIM_SEARCH_COMPLETION: () => {
    return {
      event: 'claimTrigger001',
    };
  },
  VERIFY_ELIGIBILITY_COMPLETION: () => {
    return {
      event: 'eligibilityTrigger001',
    };
  },
};
